import { render } from "./ProductDetailsComponent.vue?vue&type=template&id=04213614"
import script from "./ProductDetailsComponent.vue?vue&type=script&lang=js"
export * from "./ProductDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/pos/ProductDetailsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04213614"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04213614', __exports__)) {
    api.reload('04213614', __exports__)
  }
  
  module.hot.accept("./ProductDetailsComponent.vue?vue&type=template&id=04213614", () => {
    api.rerender('04213614', render)
  })

}


export default __exports__